export default __webpack_public_path__ + "static/media/DropBox.a218dbe5.svg";